import * as React from "react";
import NextLink from "next/link";
import { A as BaseA, AProps, Button as BaseButton, ButtonProps } from "@nju/ui";

export function Button({
  isPrimary,
  ...props
}: React.PropsWithChildren<ButtonProps & { isPrimary?: boolean }>) {
  return (
    <BaseButton
      size={{
        "@onlyMobile": "s",
        "@fromTablet": "m",
      }}
      variant={isPrimary ? "primary" : "secondary"}
      {...props}
    />
  );
}

export function Link({
  isPrimary,
  href,
  ...props
}: React.PropsWithChildren<AProps & { isPrimary?: boolean; href: string }>) {
  return (
    <NextLink href={href} passHref={true}>
      <BaseA
        size={{
          "@onlyMobile": "s",
          "@fromTablet": "m",
        }}
        variant={isPrimary ? "primary" : "secondary"}
        {...props}
      />
    </NextLink>
  );
}
